export default __webpack_public_path__ + "static/media/success.cb43fc34.svg";